import { useSelector } from "react-redux";
import store from "../storeWire";
import {
    getForecastData,
    setOpenAccordionList,
    forecastShare
} from "../store/slice/model/Forecast";
import ForecastRepository from "src/repository/ForecastRepository";

export function useForecastStore() {
    const forecast_list = useSelector((state) => state.entities.model_Forecast.forecastList)
    const forecast_counts = useSelector((state) => state.entities.model_Forecast.forecastCounts)
    const last_forecast_receive_date = useSelector((state) => state.entities.model_Forecast.lastForecastReceivedDate)
    const forecast_detail_list = useSelector((state) => state.entities.model_Forecast.forecastDetailList)
    const forecast_date_columns = useSelector((state) => state.entities.model_Forecast.forecastDateColumns)
    const forecast_open_accordion_list = useSelector((state) => state.entities.model_Forecast.openAccordionList)

    let data = {
        forecast_list,
        forecast_counts,
        last_forecast_receive_date,
        forecast_detail_list,
        forecast_date_columns,
        forecast_open_accordion_list
    };
    let fetch = {
        get_forecast_data: async (params) => {
            return await store.dispatch(getForecastData(params))
        },
        get_forecast_count: async() => {
            return await new ForecastRepository().getForecastCount();
        },
        download_forecast: async(params) => {
            return await new ForecastRepository().downloadForecast(params);
        }
    };
    let set = {
        set_open_accordion_list: async (id) => {
            return await store.dispatch(setOpenAccordionList(id))
        },
        forecast_share: async (params) => {
            return await store.dispatch(forecastShare(params))
        },
    };
    return [data, fetch, set]
}